import PropTypes from 'prop-types'

/**
 *
 * @param {{
 *  href: string,
 *  action?: 'default'|'primary'|'success',
 *  size?: 'normal'|'large',
 *  disabled?: boolean,
 *  className?:string}
 * } props
 * @returns
 */
export default function LinkButton({
  href,
  children,
  action,
  size,
  disabled,
  className,
  ...props
}) {
  return (
    <a
      href={href}
      disabled={disabled}
      className={`
      tw-custom-btn
      tw-custom-link-${action} 
      tw-custom-btn-${size}
      tw-block
      tw-text-center
      hover:tw-no-underline
      focus:tw-no-underline
      ${className}`}
      {...props}>
      {children}
    </a>
  )
}

LinkButton.defaultProps = {
  action: 'default',
  size: 'normal',
}

LinkButton.propTypes = {
  onClick: PropTypes.any,
  children: PropTypes.node,
  action: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  className: PropTypes.string,
}

export function Link({ href, children, className, ...props }) {
  return (
    <a
      href={href}
      className={`
    tw-custom-uppercase 
    tw-text-base 
    tw-text-primary 
    tw-transition-all 
    tw-duration-100 
    tw-ease-linear
    hover:tw-text-primary-hover hover:tw-no-underline 
    focus:tw-no-underline focus:tw-text-primary-hover
    ${className || ''}`}
      {...props}>
      {children}
    </a>
  )
}

Link.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  className: PropTypes.string,
}
